<template>
  <div id="index">
    <router-link to="/mains">
      <img src="/static/images/7plus_logo.png" />
    </router-link>
     <span  v-if="divVisible" >
       <router-link to="/">[ログインへ]</router-link>   
      &nbsp;&nbsp;&nbsp;&nbsp;  
       ユーザ：{{ user }}
       &nbsp;&nbsp;&nbsp;&nbsp;  
       <a v-if="canChangeYear"  id="prevYear" hlef="#" @click="changeYear(-1);">前の年</a>
       <b v-if="year">{{ year }}年</b>
       <a  v-if="canChangeYear"  id="nextYear" hlef="#" @click="changeYear(1);">次の年</a>
       
        </span> 
    <hr/>

    <!-- 遷移間パラメータ：{{ $route.params }}
    <hr/>
    <br/><br/> -->

    <router-view/>
  </div>
</template>

<script>
  export default {
    name: "index",
    data() {
      return {
          divVisible: false,
          user: '',
          year: '',
          canChangeYear :false,
      }
    },
    mounted() {
      this.showTitle(this.$route.name);
    },
    watch:{
        $route (to, from){
          this.showTitle(to.name);
        }
    } ,
    methods: {
      showTitle: function (curRoute) {
        var self = this;
        self.divVisible=false;
        self.user="";
        self.year="";
        if(curRoute=="login" || curRoute=="login2" || curRoute=="mains" ){
           return;
        }
        // サーバ側処理呼び出す
        new Promise(function (request, response) {
          var data = self.$route.params;
          common.getAxios().post(process.env.API_URL +"/api/IndexInit", data )
            .then(function (res) {
              if (res.data) {
                self.user = res.data.user;
                if(curRoute=="userManage" || curRoute=="userDetail" || curRoute=="syncAWS" ){
                    self.year = null;
                    self.canChangeYear =false;
                }else if(curRoute=="questionnaireAnswerDetails" || curRoute=="questionnaireAnswer" || curRoute=="eloBatch"){
                    self.year = res.data.evaluation_year;
                    self.canChangeYear =false;
                }else{
                    self.year = res.data.year;
                    self.canChangeYear= true;
                }
                self.divVisible = true;
              }
            })
            .catch(function (err) {
              alert(err);
            });
        });

      },
      changeYear: function (offset) {
        var self = this;
        $("#prevYear").attr("disabled", true);
        $("#nextYear").attr("disabled", true);
        // サーバ側処理呼び出す
        new Promise(function (request, response) {
          var data = { offset: offset};
          common.getAxios().post(process.env.API_URL +"/api/IndexChangeYear", data)
            .then(function (res) {
              $("#prevYear").attr("disabled", false);
              $("#nextYear").attr("disabled", false);
              // 処理正常の場合
              if (res.data.message == '') {
                //self.$router.push({ name: 'mains', params: { } });
                //self.year = res.data.year;
                sessionStorage.setItem(common.TOKEN_KEY,res.data.token);
                self.$router.go()
              }
              // 処理エラーの場合
              else {
                alert(res.data.message);
              }
            })
            .catch(function (err) {
              alert(err);
              $("#prevYear").attr("disabled", false);
              $("#nextYear").attr("disabled", false);
            });
        });
      },
    }
  };
</script>





// WEBPACK FOOTER //
// index.vue?6d4538ea